/* brand.tsx Brand component that displays logo and slogan */
import React from "react";
import { style, classes } from "./brand.st.css";

/**
 * Brand props.
 */
interface BrandProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional alt text for logo */
  altText?: string;
  /** Logo link and logo text */
  logoHref?: string;
  logoText?: string;
  /** Logo width height, if provided */
  logoHeight?: number;
  logoWidth?: number;
  /** If image path given then it will show the image */
  imgHref?: string;
}

const Brand = ({
  altText,
  className,
  logoHref,
  logoText,
  imgHref,
  logoWidth,
  logoHeight,
  ...rest
}: BrandProps) => {
  return (
    <div className={style(classes.root, className)} {...rest}>
      {imgHref ? (
        <a
          href={logoHref}
          className={`${classes.withImage} ${classes.logoLink}`}
        >
          {logoText}
          <img
            width={logoWidth}
            height={logoHeight}
            alt={altText}
            className={classes.logoImg}
            src={imgHref}
          />
        </a>
      ) : (
        <a className={classes.logoLink} href={logoHref}>
          {logoText}
        </a>
      )}
    </div>
  );
};

export default Brand;
